<template>
  <div class="help">
    <div class="backcolor" :style="$route.query.pt == 'app' ? {'padding-top': '0.64rem'} : {'padding-top': '0'}">
      <!--v-if="$route.query.pt == 'app'"-->
      <div class="header" v-if="$route.query.pt == 'app'">
        <van-icon name="arrow-left" size="0.2rem" color="#222222" @click="goBack"/>
        <div class="text">帮助中心</div>
      </div>
      <div class="title">
        <van-icon :name="require('../../assets/images/help/love.png')" size="0.32rem"/>
        <span>Hi,很高兴为你服务！</span>
      </div>
    </div>
    <div class="list">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item :name="index"  v-for="(item, index) of list" :key="index">
          <div slot="title">
            <img class="imgStyle" :src="item.img">
            <div class="titletext">
              <span>{{item.title}}</span>
              <i>{{item.content}}</i>
            </div>
          </div>
          <ul class="content">
            <li v-for="(itemSon, indexSon) of item.children" :key="itemSon" @click="goHelpDetail(index, indexSon)">
              {{itemSon}}<van-icon name="arrow" color="#dddd" size="0.15rem" />
            </li>
          </ul>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Collapse, CollapseItem } from 'vant'
import { isWeixin, fenxiang, isApp } from '../../assets/common/js/config'

Vue.use(Collapse).use(CollapseItem)

export default {
  name: 'help',
  data () {
      return {
        activeName: null,
        list: [
          {
            title: '常见问题',
            // content: '下载APP、购买商品、联系客服等',
            content: '购买商品、联系客服等',
            img: require('../../assets/images/help/icon1.png'),
            children : [
              // '如何正确下载新版APP',
              '如何购买商品',
              '如何联系客服',
              '商城支付方式说明'
            ]
          },
          {
            title: '订单问题',
            content: '收货地址、查看物流等',
            img: require('../../assets/images/help/icon2.png'),
            children : [
              '如何变更订单收货地址',
              '如何查看物流信息'
            ]
          },
          {
            title: '配送与验收',
            content: '发货时间、配送范围及费用等',
            img: require('../../assets/images/help/icon3.png'),
            children : [
              '发货时间',
              '配送范围及费用',
              '商品验货与签收'
            ]
          },
          {
            title: '售后问题',
            content: '售后处理范畴',
            img: require('../../assets/images/help/icon4.png'),
            children : [
              '售后处理范畴'
            ]
          }
        ]
      }
  },
  mounted () {
    if (isWeixin()) {
      fenxiang({path: 'help'})
    }
  },
  methods: {
    goHelpDetail (id, idson) {
      var arg = isApp()
      if (this.$route.query.pt && this.$route.query.pt == 'app') {
        var obj = {
          'type': 'helpcontent',
          'id': id,
          'idson': idson
        }
        window.ReactNativeWebView.postMessage(
          JSON.stringify(obj)
        )
      } else if (this.$route.query.pt && this.$route.query.pt == 'xcx') {
        var obj = this.$route.query
        obj.id = id
        obj.idson = idson
        this.$router.push({
          path: '/helpcontent',
          query: obj
        })
      } else {
        this.$router.push({
          path: '/helpcontent',
          query: {
            id: id,
            idson: idson
          }
        })
      }

    },
    goBack () {
      var type = 'help'
      var obj = {
        'type': type
      }
      window.ReactNativeWebView.postMessage(
        JSON.stringify(obj)
      )
    }
  }
}
</script>

<style scoped lang="scss">
  .help .header, .help .title, .help .list, .help .list .content li {
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
  }
  .help {
    .backcolor {
      background:linear-gradient(180deg,rgba(254,248,241,1) 0%,rgba(250,235,214,1) 100%);
      background:-webkit-linear-gradient(180deg,rgba(254,248,241,1) 0%,rgba(250,235,214,1) 100%);
      background:-moz-linear-gradient(180deg,rgba(254,248,241,1) 0%,rgba(250,235,214,1) 100%);
      background:-o-linear-gradient(180deg,rgba(254,248,241,1) 0%,rgba(250,235,214,1) 100%);
      background:-ms-linear-gradient(180deg,rgba(254,248,241,1) 0%,rgba(250,235,214,1) 100%);
    }
    .header {
      height: 0.64rem;
      padding: 0 0.06rem;
      padding-top: 0.2rem;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      .text {
        flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -o-flex: 1;
        -ms-flex: 1;
        text-align: center;
        font-size:0.17rem;
        font-weight:400;
        color:rgba(34,34,34,1);
        line-height:0.24rem;
      }
    }
    .title {
      height: 1.41rem;
      font-size: 0;
      text-align: center;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -o-justify-content: center;
      -ms-justify-content: center;
      i {
        vertical-align: bottom;
        margin-top: -0.2rem;
      }
      span {
        margin-left: 0.11rem;
        font-size:0.22rem;
        font-weight:600;
        color:rgba(50,50,50,1);
        line-height:0.3rem;
        margin-top: -0.2rem;
      }
    }
    .list {
      margin: -0.41rem 0.11rem 0;
      padding: 0.03rem 0.15rem;
      background: #fff;
      border-radius: 0.04rem;
      .imgStyle {
        height: 0.5rem;
        width: 0.5rem;
        display: inline-block;
        vertical-align: bottom;
      }
      .titletext {
        display: inline-block;
        margin-left: 0.14rem;
        -webkit-flex: 1;
        -moz-flex: 1;
        -o-flex: 1;
        -ms-flex: 1;
        span {
          font-size:0.16rem;
          font-weight:600;
          color:rgba(50,50,50,1);
          line-height:0.22rem;
          display: block;
        }
        i {
          margin-top: 0.06rem;
          font-size:0.13rem;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:0.18rem;
          font-style: normal;
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 2.1rem;
        }
      }
      .content {
        padding-left: 0.14rem;
        padding-right: 0.18rem;
        background: #F6F6F6;
        li {
          justify-content: space-between;
          -webkit-justify-content: space-between;
          -moz-justify-content: space-between;
          -ms-justify-content: space-between;
          -o-justify-content: space-between;
          padding: 0.15rem 0 0.12rem;
          border-bottom: 0.01rem solid #EFEFEF;
          &:last-of-type {
            border-bottom: 0.01rem solid transparent;
          }
        }
      }
      .van-collapse {
        position: static;
        .van-hairline--top {
          /*border-top: 0.01rem solid #EFEFEF;*/
        }
      }
    }
  }
</style>
<style lang="scss">
  .help {
    .list {
      .van-collapse {
        width: 100%;
        .van-collapse-item__content {
          padding: 0;
          color: #343434;
        }
      }
      .van-collapse-item {
        border-bottom: 0.01rem solid #EFEFEF;
        position: static;
        &:last-of-type {
          border-bottom: none;
        }
      }
    }
    .van-cell {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      padding: 0.14rem 0;
    }
    .van-collapse-item__title {
      .van-cell__right-icon {
        color: #dddddd;
        size: 0.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/help.vue